import { useIntl } from "react-intl";

import { Image } from "@/components/Image/Image";
import { usePaymentContext } from "@/contexts/PaymentContext";
import { HotelRoomTitle } from "@/features/hotels/components/hotel/HotelRoomTitle";
import type { HotelBookingRoomOption } from "@/features/hotels/types/types";
import { includeBnplFee } from "@/utils/bnpl-fee";
import { formatCurrency } from "@/utils/currency";

export const HotelRoom = ({
  room,
  adultCount,
  childrenCount,
}: {
  room: HotelBookingRoomOption;
  adultCount: number;
  childrenCount: number;
}) => {
  const { paymentType, selectedInstallments } = usePaymentContext();
  const intl = useIntl();
  const roomImage = room.images?.[0];

  const payLaterPrice = includeBnplFee(room.price?.value || 0);
  return (
    <div className="flex w-full justify-between gap-4 rounded-2xl bg-[#F3F4F7] p-3">
      <div className="text-sm font-medium">
        <div className="mb-2">
          <HotelRoomTitle
            name={room.name}
            board={room.board}
            occupancy={{
              numberOfAdults: adultCount,
              numberOfChildren: childrenCount,
            }}
          />
        </div>
        <div className="font-bold">
          <span>
            {formatCurrency(
              paymentType === "bnpl"
                ? payLaterPrice / selectedInstallments
                : room.price?.value,
              room.price?.currency,
            )}
          </span>
          {paymentType === "bnpl" && (
            <span>
              {" "}
              {intl.formatMessage({
                defaultMessage: "per month",
                description:
                  "Short 'per month' unit label used next to instalment prices",
              })}
            </span>
          )}
        </div>
      </div>

      {roomImage ? (
        <div className="relative h-[48px] w-[60px] overflow-clip rounded-lg">
          <Image
            className="h-full w-full object-cover"
            src={roomImage.url}
            alt={roomImage.name}
          />
        </div>
      ) : null}
    </div>
  );
};
